/**
 * Netting configuration per provider.
 *
 * Key: integration_technical_name of the provider
 *
 * Available modes: 'file_upload', 'ftps', 'api'
 *
 * - pro: process mode for the PRO block (null = no PRO block)
 *
 * The Particuliers block is always present and uses the backend's netting_process_type.
 */
const NETTING_CONFIG = {
  totalenergies: {
    pro: 'file_upload',
  },
}

/**
 * Returns the PRO netting config for a given provider.
 *
 * @param {string|null|undefined} technicalName - integration_technical_name of the provider
 * @returns {{ pro: string|null }}
 */
export const getNettingConfig = (technicalName) => {
  if (technicalName && NETTING_CONFIG[technicalName]) {
    return NETTING_CONFIG[technicalName]
  }
  return { pro: null }
}

/**
 * Checks whether a provider supports PRO netting.
 * @param {string|null|undefined} technicalName - integration_technical_name of the provider
 * @returns {boolean}
 */
export const hasProNetting = (technicalName) => {
  const config = technicalName && NETTING_CONFIG[technicalName]
  return Boolean(config?.pro)
}
